import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const sendPasswordResetEmail = async (email: string) => {
  const query = `
     mutation($email: String!) {
      authenticate {
        initiateResetPassword(sendPasswordMailVM: { email: $email }) {
          messageCode
          succeed
          data {
            id
          }
        }
      }
    }
  `;

  return await authenticationGraph<
    { succeed: boolean; messageCode: string },
    {
      authenticate: {
        initiateResetPassword: JsonResponseType<{
          succeed: boolean;
          messageCode: string;
        }>;
      };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: { email },
    },
    (input) => input.authenticate.initiateResetPassword,
  );
};
